module.exports = __webpack_public_path__ + "static/effizientere-marktzulassung-3aec23ef7726eeb4606585252613a96e.png";